// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Modules
import ReactPaginate from 'react-paginate';
// Design systems
import { Icon } from '@utmb/design-system/icons/Icon';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
// Contexts
import { useGlobal } from '@utmb/contexts/GlobalContext';
// Styles
import styles from './pagination.module.scss';

interface Pagination {
    forcePage: number;
    PageCount: number;
    isMobile?: boolean;
    onPageChange: (event: { selected: number }) => void;
    hrefBuilder?: (page: number, pageCount: number) => void;
}

export const Pagination = ({ forcePage = 0, onPageChange, PageCount = 0, isMobile = true, hrefBuilder }: Pagination): ReactElement => {
    const { global } = useGlobal();
    const { t } = useTranslation();

    const rangeDisplayed = global?.isMobile ? 1 : 2;

    return (
        <ReactPaginate
            forcePage={forcePage}
            onPageChange={onPageChange}
            breakLabel="..."
            previousLabel={<Icon variant={IconsEnum.CHEVRON_LEFT} />}
            nextLabel={<Icon variant={IconsEnum.CHEVRON_RIGHT} />}
            pageRangeDisplayed={rangeDisplayed}
            marginPagesDisplayed={rangeDisplayed}
            pageCount={PageCount}
            pageClassName={styles.paginate_item}
            pageLinkClassName={styles.paginate_link}
            previousClassName={styles.paginate_item}
            previousLinkClassName={styles.paginate_link}
            nextClassName={styles.paginate_item}
            nextLinkClassName={styles.paginate_link}
            breakClassName={styles.paginate_item}
            breakLinkClassName={styles.paginate_link}
            containerClassName={styles.paginate_container}
            activeClassName={styles.paginate_active}
            disabledClassName={styles.paginate_disabled}
            hrefBuilder={hrefBuilder}
        />
    );
};
